module.exports = __webpack_public_path__ + "img/tides-logo.0e89801d.svg";